import type { User } from '../../user/types/User';

export const getMixpanelVisitorSuperProperties = (
    visitorId: string,
): Record<string, string | boolean> => ({
    visitorId,
    isVisitor: true,
});

export const getMixpanelUserProperties = (
    user: User,
): Record<string, string | boolean | null> => ({
    $email: user.email,
    $first_name: user.firstName,
    $last_name: user.lastName,
    isVisitor: false,
    ...(user.visitorId != null && user.visitorId !== ''
        ? { visitorId: user.visitorId }
        : {}),
});

export const getCustomerIOTraits = (
    user: User,
): Record<string, string | boolean | null> => ({
    firstName: user.firstName,
    lastName: user.lastName,
    email: user.email,
    isVisitor: false,
    ...(user.visitorId != null && user.visitorId !== ''
        ? { visitorId: user.visitorId, anonymous_id: user.visitorId }
        : {}),
});
